module.exports = __webpack_public_path__ + "img/e00c48d.jpg";